// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage {
    width: 100vw;
    height: 100vh;
    background: linear-gradient(160deg, #222423 0%, #0e0f10 100%);
    display: flex;
    flex-direction: row;
}

.LoginLeftBanner {
    width: 40%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    position: relative;
}

.LoginLeftBanner::before {
    width: 100%;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to left, #0e0f10 0%, rgba(14, 15, 16, 0.8) 3%, rgba(14, 15, 16, 0) 15%), linear-gradient(to top, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 0.1) 80%);
}

.LoginLeftBannerText {
    position: relative;
    z-index: 1;
    color: #fff;
    top: 100%;
    left: 3%;
    transform: translateY(-180%);
    h1 {
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 10px;
        line-height: 1.3;
    }
    p {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.6);
        line-height: 1.6;
    }
}

.LoginRight {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
        width: 200px;
        height: 70px;
        object-fit: cover;
        /*object-position: center;*/
    }
    label {
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.45);
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 2px;
        background: none;
        margin-bottom: 22px;
        padding: 0;
        border: none;
    }
    input {
        outline: none;
        background: #ffffff;
        width: 30%;
        border: 2px solid transparent;
        margin: 0 0 14px;
        padding: 14px 16px;
        font-size: 14px;
        border-radius: 8px;
        color: #1a1a1a;
        transition: all 0.2s ease;
    }
    button {
        text-transform: uppercase;
        outline: none;
        background: linear-gradient(135deg, #43e97b 0%, #38c172 100%);
        width: 33.3%;
        height: 48px;
        border: none;
        padding: 15px;
        border-radius: 8px;
        color: #000;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 1.2px;
        transition: all 0.2s ease;
        cursor: pointer;
        margin-top: 6px;
        span {
            display: inline-block;
            font: normal normal normal 10px / 1 'FontAwesome';
            font-size: inherit;
            text-rendering: auto;
            color: inherit;
            -webkit-font-smoothing: antialiased;
            font-weight: 700;
            letter-spacing: 1px;
        }
    }

    button:hover {
        filter: brightness(1.08);
    }

    .register-link {
        text-transform: uppercase;
        text-align: center;
        outline: none;
        background: rgba(255, 255, 255, 0.06);
        width: 30.5%;
        border: 1px solid rgba(255, 255, 255, 0.18);
        margin-top: 12px;
        font-weight: 600;
        display: block;
        padding: 15px;
        border-radius: 8px;
        color: rgba(255, 255, 255, 0.85) !important;
        font-size: 10px;
        letter-spacing: 1.2px;
        transition: all 0.2s ease;
        cursor: pointer;
        text-decoration: none;
        span {
            display: inline-block;
            font: normal normal normal 10px / 1 'FontAwesome';
            font-size: inherit;
            text-rendering: auto;
            color: inherit;
            -webkit-font-smoothing: antialiased;
        }
    }

    .disabled {
        pointer-events: none;
        cursor: default;
        filter: brightness(0.4);
    }

    .register-link:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.28);
        color: #ffffff !important;
    }

    p {
        text-align: center;
        margin-top: 28px;
        font-size: 14px;
        a {
            color: rgba(255, 255, 255, 0.45);
            text-decoration: none;
            transition: color 0.2s ease;
            cursor: pointer;
        }
        a:hover {
            color: rgba(255, 255, 255, 0.85);
        }
    }
    .error-form {
        /*display: none;*/
        width: 30.3%;
        color: #ff6b6b;
        font-weight: 500;
        text-align: center;
        margin-bottom: 16px;
        font-size: 13px;
        padding: 13px 16px;
        background: rgba(255, 107, 107, 0.1);
        border-radius: 8px;
        border: 1px solid rgba(255, 107, 107, 0.2);
    }

    /*.banned-account-msg {*/
    /*    display: none;*/
    /*}*/

    /*.unconfirmed-account {*/
    /*    display: none;*/
    /*}*/

    /*.bad-credentials {*/
    /*    display: none;*/
    /*}*/
}

/* ============================
   📱 RESPONSIVE LOGIN (MOBILE)
   ============================ */
@media (max-width: 768px) {

    .LoginPage {
        flex-direction: column;
        height: auto;
        min-height: 100vh;
    }

    .LoginLeftBanner {
        width: 100%;
        height: 200px;
        background-position: center;
    }

    .LoginLeftBannerText {
        top: 50%;
        transform: translateY(-50%);
        left: 5%;
    }

    .LoginLeftBannerText h1 {
        font-size: 22px;
    }

    .LoginLeftBannerText p {
        font-size: 12px;
    }

    .LoginRight {
        width: 100%;
        padding: 20px;
        margin-top: 20px;
    }

    .LoginRight img {
        width: 160px;
        height: auto;
    }

    .LoginRight input,
    .LoginRight button,
    .LoginRight .register-link,
    .LoginRight .error-form {
        width: 100% !important;
        max-width: 100%;
    }

    .LoginRight input {
        font-size: 15px;
        padding: 14px;
    }

    .LoginRight button {
        height: 50px;
        font-size: 12px;
    }

    .LoginRight .register-link {
        font-size: 12px;
        padding: 14px;
    }

    .LoginRight p {
        font-size: 14px;
    }
}

/* ============================
   📱 PETITS TÉLÉPHONES (≤ 480px)
   ============================ */
@media (max-width: 480px) {

    .LoginLeftBanner {
        height: 160px;
    }

    .LoginLeftBannerText h1 {
        font-size: 18px;
    }

    .LoginLeftBannerText p {
        font-size: 11px;
    }

    .LoginRight img {
        width: 140px;
    }

    .LoginRight input {
        font-size: 14px;
        padding: 12px;
    }

    .LoginRight button {
        height: 46px;
        font-size: 11px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yDAA4C;IAC5C,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oMAAoM;AACxM;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,QAAQ;IACR,4BAA4B;IAC5B;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,+BAA+B;QAC/B,gBAAgB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,2BAA2B;IAC/B;IACA;QACI,yBAAyB;QACzB,gCAAgC;QAChC,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,UAAU;QACV,YAAY;IAChB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,UAAU;QACV,6BAA6B;QAC7B,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,cAAc;QACd,yBAAyB;IAC7B;IACA;QACI,yBAAyB;QACzB,aAAa;QACb,6DAA6D;QAC7D,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,qBAAqB;QACrB,yBAAyB;QACzB,eAAe;QACf,eAAe;QACf;YACI,qBAAqB;YACrB,iDAAiD;YACjD,kBAAkB;YAClB,oBAAoB;YACpB,cAAc;YACd,mCAAmC;YACnC,gBAAgB;YAChB,mBAAmB;QACvB;IACJ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,aAAa;QACb,qCAAqC;QACrC,YAAY;QACZ,2CAA2C;QAC3C,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,kBAAkB;QAClB,2CAA2C;QAC3C,eAAe;QACf,qBAAqB;QACrB,yBAAyB;QACzB,eAAe;QACf,qBAAqB;QACrB;YACI,qBAAqB;YACrB,iDAAiD;YACjD,kBAAkB;YAClB,oBAAoB;YACpB,cAAc;YACd,mCAAmC;QACvC;IACJ;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,oCAAoC;QACpC,uCAAuC;QACvC,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QACf;YACI,gCAAgC;YAChC,qBAAqB;YACrB,2BAA2B;YAC3B,eAAe;QACnB;QACA;YACI,gCAAgC;QACpC;IACJ;IACA;QACI,iBAAiB;QACjB,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,oCAAoC;QACpC,kBAAkB;QAClB,0CAA0C;IAC9C;;IAEA,wBAAwB;IACxB,qBAAqB;IACrB,IAAI;;IAEJ,yBAAyB;IACzB,qBAAqB;IACrB,IAAI;;IAEJ,qBAAqB;IACrB,qBAAqB;IACrB,IAAI;AACR;;AAEA;;iCAEiC;AACjC;;IAEI;QACI,sBAAsB;QACtB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,QAAQ;QACR,2BAA2B;QAC3B,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;;;;QAII,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;iCAEiC;AACjC;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ","sourcesContent":[".LoginPage {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: linear-gradient(160deg, #222423 0%, #0e0f10 100%);\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.LoginLeftBanner {\r\n    width: 40%;\r\n    height: 100%;\r\n    background-image: url(\"../assets/login.png\");\r\n    background-size: cover;\r\n    position: relative;\r\n}\r\n\r\n.LoginLeftBanner::before {\r\n    width: 100%;\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: linear-gradient(to left, #0e0f10 0%, rgba(14, 15, 16, 0.8) 3%, rgba(14, 15, 16, 0) 15%), linear-gradient(to top, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 0.1) 80%);\r\n}\r\n\r\n.LoginLeftBannerText {\r\n    position: relative;\r\n    z-index: 1;\r\n    color: #fff;\r\n    top: 100%;\r\n    left: 3%;\r\n    transform: translateY(-180%);\r\n    h1 {\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n        margin-bottom: 10px;\r\n        line-height: 1.3;\r\n    }\r\n    p {\r\n        font-size: 13px;\r\n        color: rgba(255, 255, 255, 0.6);\r\n        line-height: 1.6;\r\n    }\r\n}\r\n\r\n.LoginRight {\r\n    width: 60%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    img {\r\n        width: 200px;\r\n        height: 70px;\r\n        object-fit: cover;\r\n        /*object-position: center;*/\r\n    }\r\n    label {\r\n        text-transform: uppercase;\r\n        color: rgba(255, 255, 255, 0.45);\r\n        font-size: 11px;\r\n        font-weight: 600;\r\n        letter-spacing: 2px;\r\n        background: none;\r\n        margin-bottom: 22px;\r\n        padding: 0;\r\n        border: none;\r\n    }\r\n    input {\r\n        outline: none;\r\n        background: #ffffff;\r\n        width: 30%;\r\n        border: 2px solid transparent;\r\n        margin: 0 0 14px;\r\n        padding: 14px 16px;\r\n        font-size: 14px;\r\n        border-radius: 8px;\r\n        color: #1a1a1a;\r\n        transition: all 0.2s ease;\r\n    }\r\n    button {\r\n        text-transform: uppercase;\r\n        outline: none;\r\n        background: linear-gradient(135deg, #43e97b 0%, #38c172 100%);\r\n        width: 33.3%;\r\n        height: 48px;\r\n        border: none;\r\n        padding: 15px;\r\n        border-radius: 8px;\r\n        color: #000;\r\n        font-size: 10px;\r\n        font-weight: 700;\r\n        letter-spacing: 1.2px;\r\n        transition: all 0.2s ease;\r\n        cursor: pointer;\r\n        margin-top: 6px;\r\n        span {\r\n            display: inline-block;\r\n            font: normal normal normal 10px / 1 'FontAwesome';\r\n            font-size: inherit;\r\n            text-rendering: auto;\r\n            color: inherit;\r\n            -webkit-font-smoothing: antialiased;\r\n            font-weight: 700;\r\n            letter-spacing: 1px;\r\n        }\r\n    }\r\n\r\n    button:hover {\r\n        filter: brightness(1.08);\r\n    }\r\n\r\n    .register-link {\r\n        text-transform: uppercase;\r\n        text-align: center;\r\n        outline: none;\r\n        background: rgba(255, 255, 255, 0.06);\r\n        width: 30.5%;\r\n        border: 1px solid rgba(255, 255, 255, 0.18);\r\n        margin-top: 12px;\r\n        font-weight: 600;\r\n        display: block;\r\n        padding: 15px;\r\n        border-radius: 8px;\r\n        color: rgba(255, 255, 255, 0.85) !important;\r\n        font-size: 10px;\r\n        letter-spacing: 1.2px;\r\n        transition: all 0.2s ease;\r\n        cursor: pointer;\r\n        text-decoration: none;\r\n        span {\r\n            display: inline-block;\r\n            font: normal normal normal 10px / 1 'FontAwesome';\r\n            font-size: inherit;\r\n            text-rendering: auto;\r\n            color: inherit;\r\n            -webkit-font-smoothing: antialiased;\r\n        }\r\n    }\r\n\r\n    .disabled {\r\n        pointer-events: none;\r\n        cursor: default;\r\n        filter: brightness(0.4);\r\n    }\r\n\r\n    .register-link:hover {\r\n        background: rgba(255, 255, 255, 0.1);\r\n        border-color: rgba(255, 255, 255, 0.28);\r\n        color: #ffffff !important;\r\n    }\r\n\r\n    p {\r\n        text-align: center;\r\n        margin-top: 28px;\r\n        font-size: 14px;\r\n        a {\r\n            color: rgba(255, 255, 255, 0.45);\r\n            text-decoration: none;\r\n            transition: color 0.2s ease;\r\n            cursor: pointer;\r\n        }\r\n        a:hover {\r\n            color: rgba(255, 255, 255, 0.85);\r\n        }\r\n    }\r\n    .error-form {\r\n        /*display: none;*/\r\n        width: 30.3%;\r\n        color: #ff6b6b;\r\n        font-weight: 500;\r\n        text-align: center;\r\n        margin-bottom: 16px;\r\n        font-size: 13px;\r\n        padding: 13px 16px;\r\n        background: rgba(255, 107, 107, 0.1);\r\n        border-radius: 8px;\r\n        border: 1px solid rgba(255, 107, 107, 0.2);\r\n    }\r\n\r\n    /*.banned-account-msg {*/\r\n    /*    display: none;*/\r\n    /*}*/\r\n\r\n    /*.unconfirmed-account {*/\r\n    /*    display: none;*/\r\n    /*}*/\r\n\r\n    /*.bad-credentials {*/\r\n    /*    display: none;*/\r\n    /*}*/\r\n}\r\n\r\n/* ============================\r\n   📱 RESPONSIVE LOGIN (MOBILE)\r\n   ============================ */\r\n@media (max-width: 768px) {\r\n\r\n    .LoginPage {\r\n        flex-direction: column;\r\n        height: auto;\r\n        min-height: 100vh;\r\n    }\r\n\r\n    .LoginLeftBanner {\r\n        width: 100%;\r\n        height: 200px;\r\n        background-position: center;\r\n    }\r\n\r\n    .LoginLeftBannerText {\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 5%;\r\n    }\r\n\r\n    .LoginLeftBannerText h1 {\r\n        font-size: 22px;\r\n    }\r\n\r\n    .LoginLeftBannerText p {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .LoginRight {\r\n        width: 100%;\r\n        padding: 20px;\r\n        margin-top: 20px;\r\n    }\r\n\r\n    .LoginRight img {\r\n        width: 160px;\r\n        height: auto;\r\n    }\r\n\r\n    .LoginRight input,\r\n    .LoginRight button,\r\n    .LoginRight .register-link,\r\n    .LoginRight .error-form {\r\n        width: 100% !important;\r\n        max-width: 100%;\r\n    }\r\n\r\n    .LoginRight input {\r\n        font-size: 15px;\r\n        padding: 14px;\r\n    }\r\n\r\n    .LoginRight button {\r\n        height: 50px;\r\n        font-size: 12px;\r\n    }\r\n\r\n    .LoginRight .register-link {\r\n        font-size: 12px;\r\n        padding: 14px;\r\n    }\r\n\r\n    .LoginRight p {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n/* ============================\r\n   📱 PETITS TÉLÉPHONES (≤ 480px)\r\n   ============================ */\r\n@media (max-width: 480px) {\r\n\r\n    .LoginLeftBanner {\r\n        height: 160px;\r\n    }\r\n\r\n    .LoginLeftBannerText h1 {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .LoginLeftBannerText p {\r\n        font-size: 11px;\r\n    }\r\n\r\n    .LoginRight img {\r\n        width: 140px;\r\n    }\r\n\r\n    .LoginRight input {\r\n        font-size: 14px;\r\n        padding: 12px;\r\n    }\r\n\r\n    .LoginRight button {\r\n        height: 46px;\r\n        font-size: 11px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
